import { useEffect } from 'react';
const title = 'Turnout: Pre-Booked Meetings for Conference Exhibitors';
const description = 'Turnout helps B2B conference exhibitors identify the right attendees, run pre-show outreach, and book qualified meetings before the show opens.';
export function Metadata() {
  useEffect(() => {
    document.title = title;
    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
  }, []);
  return null;
}
function setMetaTag(attribute: 'name' | 'property', key: string, value: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = value;
}